import { useDispatch, useSelector } from "react-redux";

import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import {
    fetchContactsFromActionsPanelThunk,
    revealTopNContactsWithToastThunk,
} from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/effects";
import ActiveContactsRevealPanelBaseContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/containers/ActiveContactsRevealPanel/ActiveContactsRevealPanelBaseContainer";
import { useContactsFlowStrategy } from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext";
import useActivePanelLifeCycle from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useActivePanelLifeCycle";
import { setIsActionPanelActivated } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/action-creators";
import { revealMultipleContactsByIdWithToastThunk } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/effects-reveal";
import { selectActionsPanelFilters } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { ContactRevealByIdRequestDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

const ActiveContactsRevealPanelContainer = (props: BaseActivatedPanelProps) => {
    const dispatch = useDispatch();
    const contactsFlowStrategy = useContactsFlowStrategy();
    const { params } = useCurrentStateAndParamsWithFixedDomain();
    const actionsPanelFilters = useSelector(selectActionsPanelFilters);

    useActivePanelLifeCycle();

    async function handleSubmit(topNOrIds: number | readonly ContactRevealByIdRequestDto[], onDone: () => void) {
        try {
            if (typeof topNOrIds === "number") {
                await dispatch(revealTopNContactsWithToastThunk(params.key, topNOrIds));
            } else {
                await dispatch(
                    revealMultipleContactsByIdWithToastThunk(topNOrIds, contactsFlowStrategy.dataSource.revealMultiple),
                );
            }

            void dispatch(fetchContactsFromActionsPanelThunk(params.key, actionsPanelFilters));
            onDone();
        } finally {
            dispatch(setIsActionPanelActivated(false));
        }
    }

    return (
        <ActiveContactsRevealPanelBaseContainer
            {...props}
            onSubmit={handleSubmit}
        />
    );
};

export default ActiveContactsRevealPanelContainer;
